export default __webpack_public_path__ + "static/media/hero-image-min.0644fff9.png";